import React, { useState } from 'react';
import { Text, TouchableOpacity, StyleSheet } from 'react-native';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';

interface ConfigGhostButtonProps {
  label: string;
  onPress?: () => void;
  disabled?: boolean;
}

/**
 * Row action button (Edit, Disable, Enable): the mockup's `.btn.btn-ghost.btn-sm`.
 * Transparent background and no border, 32px high, 14px bold secondary text.
 * Hover shows the subtle row-hover background with blue text.
 * AdminButton's ghost variant draws a grey border, so it is not used here.
 */
const ConfigGhostButton: React.FC<ConfigGhostButtonProps> = ({ label, onPress, disabled }) => {
  const [hovered, setHovered] = useState(false);
  const hoverProps = {
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
  } as any; // react-native-web forwards mouse events
  const active = hovered && !disabled;
  return (
    <TouchableOpacity
      {...hoverProps}
      style={[styles.btn, active && styles.btnHover, disabled && styles.disabled]}
      onPress={onPress}
      disabled={disabled}
      activeOpacity={0.7}
      accessibilityRole="button"
      accessibilityLabel={label}
    >
      <Text style={[styles.label, active && styles.labelHover]}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  btn: {
    height: 32,
    paddingHorizontal: 16,
    paddingVertical: 4,
    borderRadius: 24,
    borderWidth: 0,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnHover: { backgroundColor: '#E7EFFB' },
  disabled: { opacity: 0.45 },
  label: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '700',
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.bold,
  },
  labelHover: { color: AdminColors.blue700 },
});

export default ConfigGhostButton;
